// extracted by mini-css-extract-plugin
export default {"messageUser":"DownloadOwner_messageUser__1mA6S"};